import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=soft%20abstract%20gradient%20backdrop%20in%20warm%20cream%20and%20peach%20tones%20with%20subtle%20bokeh%20product%20silhouettes%20clean%20aesthetic%20editorial%20background&width=1600&height=500&seq=cta-bg-1&orientation=landscape&nocache=true"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-background-950/40" />
      </div>
      <div className="relative z-10 px-4 md:px-6 lg:px-8 py-16 md:py-24">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-4">
            {t('cta_main_title')}
          </h2>
          <p className="text-lg text-background-100/90 mb-8">
            {t('cta_main_desc')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('cta_main_button')}
              <i className="ri-external-link-line w-4 h-4 flex items-center justify-center" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-foreground-900 font-medium rounded-md hover:bg-background-50 transition-colors whitespace-nowrap"
            >
              {t('cta_main_button2')}
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}